import { StatusColor } from '../../../../common/constants/color.constants'
import { ChecklistStatusMap, MilestoneChecklistStatus } from '../../../../entities/workflow/constants/workflow.constants'

export function getMilestoneStatusColor(status?: MilestoneChecklistStatus): string {
  if (!status || !ChecklistStatusMap[status]) {
    return StatusColor.New
  }

  return ChecklistStatusMap[status]
}
